import { MembershipDto, UserToMembershipDto } from "@sweatpals/shared";
import { AxiosInstance } from "axios";
import { omit } from "lodash-es";

export class MembershipsService {
	private readonly basePath = 'memberships';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getCurrentUserMemberships(isActive?: boolean): Promise<UserToMembershipDto[]> {
		const { data } = await this.httpClient.get<UserToMembershipDto[]>(`${this.basePath}/current`, {
			params: {
				active: isActive,
			},
		});

		return data;
	}

	public async getPublishedMembershipsByCommunityId(communityId: string): Promise<MembershipDto[]> {
		const { data } = await this.httpClient.get<MembershipDto[]>(`${this.basePath}/public/community/${communityId}`);

		data.forEach(membship => {
			membship.tiers = membship.tiers?.map((tier) => ({
				...tier,
				membership: omit(membship, 'tiers'),
			}));
		});

		return data;
	}

	public async getPublishedMembershipById(membershipId: string): Promise<MembershipDto> {
		const { data } = await this.httpClient.get<MembershipDto>(`${this.basePath}/public/${membershipId}`);

		return data;
	}
}
